import { buildTourApiUrl } from "api/configuration";
import { http } from "api/http";

export const getCsvScanReport = (
  id: string
): Promise<string | null> => {
  const url = buildTourApiUrl(
    `/deliverytours/getCsvScanReport/${id}`
  );
  return http.fetchDownloadableFile(url, "Une erreur est survenue durant le téléchargement du fichier");
};
